import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
import moment from "moment"

const ls = new SecureLS({
    isCompression: false,
    encodingType: 'des',
    encryptionSecret: '\n isExpire: true'
});

Vue.use(Vuex)

const initialState = () => ({
    expire: 0,
    user: {},
    token: '',
    conditions: {
        shop_id: 0,
        front_id: 0,
        counselor_id: 0,
        number: "",
        phone_number: "",
        name: "",
        gender: 0,
        status: 0,
        alert: 0,
        is_exit: false,
        perPage: 50,
    },
    followStatusConditions: {
        shop_id: 0,
        counselor_id: 0,
        number: "",
        phone_number: "",
        name: "",
        gender: 0,
        status: 0,
        alert: 0,
        is_exit: false,
        perPage: 50,
        course_id: 0,
        shift_target_month: '',
    },
    staffConditions: {
        shop_id: 0,
        front_id: 0,
        counselor_id: 0,
        number: "",
        phone_number: "",
        name: "",
        gender: 0,
        status: 0,
        is_exit: false,
        perPage: 50,
    },
    alertConditions: {
        shop_id: 0,
        counselor_id: 0,
        gender: 0,
    },
    courseData: {
        course_id: 0,
        contract_date: '',
    },

    contract_date: '',
    contract_start_date: '',
    contract_end_date: '',
    contract_temp_data: {},
})

const store = new Vuex.Store({
    state: initialState,
    mutations: {
        auth(state, { user, token }) {
            state.expire = Date.now() + 604800000;
            state.user = user;
            if (token) state.token = token;
        },
        reset(state) {
            const initial = initialState();
            Object.keys(initial).forEach(key => { state[key] = initial[key] })
        },
        conds(state, conditions) {
            state.conditions.shop_id = conditions.shop_id;
            state.conditions.front_id = conditions.front_id;
            state.conditions.counselor_id = conditions.counselor_id;
            state.conditions.number = conditions.number;
            state.conditions.phone_number = conditions.phone_number;
            state.conditions.name = conditions.name;
            state.conditions.gender = conditions.gender;
            state.conditions.status = conditions.status;
            state.conditions.alert = conditions.alert;
            state.conditions.is_exit = conditions.is_exit;
            state.conditions.perPage = conditions.perPage;
        },
        followStatusConds(state, followStatusConditions) {
            state.followStatusConditions.shop_id = followStatusConditions.shop_id;
            state.followStatusConditions.counselor_id = followStatusConditions.counselor_id;
            state.followStatusConditions.number = followStatusConditions.number;
            state.followStatusConditions.phone_number = followStatusConditions.phone_number;
            state.followStatusConditions.name = followStatusConditions.name;
            state.followStatusConditions.gender = followStatusConditions.gender;
            state.followStatusConditions.status = followStatusConditions.status;
            state.followStatusConditions.alert = followStatusConditions.alert;
            state.followStatusConditions.is_exit = followStatusConditions.is_exit;
            state.followStatusConditions.perPage = followStatusConditions.perPage;
            state.followStatusConditions.course_id = followStatusConditions.course_id;
            state.followStatusConditions.shift_target_month = followStatusConditions.shift_target_month;
        },
        staffConds(state, staffConditions) {
            state.staffConditions.shop_id = staffConditions.shop_id;
            state.staffConditions.front_id = staffConditions.front_id;
            state.staffConditions.counselor_id = staffConditions.counselor_id;
            state.staffConditions.number = staffConditions.number;
            state.staffConditions.phone_number = staffConditions.phone_number;
            state.staffConditions.name = staffConditions.name;
            state.staffConditions.gender = staffConditions.gender;
            state.staffConditions.status = staffConditions.status;
            state.staffConditions.is_exit = staffConditions.is_exit;
            state.staffConditions.perPage = staffConditions.perPage;
        },
        alertConds(state, alertConditions) {
            state.alertConditions.shop_id = alertConditions.shop_id;
            state.alertConditions.counselor_id = alertConditions.counselor_id;
            state.alertConditions.gender = alertConditions.gender;
        },
        contractCourse(state, courseData) {
            state.courseData.course_id = courseData.course_id
            state.courseData.contract_date = courseData.contract_date
        },
        setContractDate(state, contractDate) {
            state.contract_date = contractDate;
        },
        setContractStartDate(state, contractStartDate) {
            state.contract_start_date = contractStartDate;
        },
        setContractEndDate(state, contractEndDate) {
            state.contract_end_date = contractEndDate;
        },
        setContractTempData(state, contractTempData) {
            state.contract_temp_data = contractTempData;
        }
    },
    actions: {
        fetch(context, { user, token }) {
            context.commit('auth', { user, token });
        },
        reset(context) {
            context.commit('reset');
        },
        setCustomerSearchConditions(context, conditions) {
            context.commit('conds', conditions);
        },
        setCustomerStaffSearchConditions(context, conditions) {
            context.commit('staffConds', conditions);
        },
        setCustomerSearchFollowStatusConditions(context, followStatusConditions) {
            context.commit('followStatusConds', followStatusConditions);
        },
        setAlertSearchConditions(context, conditions) {
            context.commit('alertConds', conditions);
        },
        setContractCourse(context, courseData) {
            context.commit('contractCourse', courseData)
        },
        updateContractDate({ commit }, contractDate) {
            commit('setContractDate', contractDate);
        },
        updateContractStartDate({ commit }, contractStartDate) {
            commit('setContractStartDate', contractStartDate);
        },
        updateContractEndDate({ commit }, contractEndDate) {
            commit('setContractEndDate', contractEndDate);
        },
        updateContractTempData({ commit }, contractTempData) {
            commit('setContractTempData', contractTempData);
        }
    },
    modules: {},
    plugins: [createPersistedState({
        key: '_token',
        storage: {
            getItem: key => {
                try {
                    return ls.get(key)
                } catch {
                    return null;
                }
            },
            setItem: (key, value) => ls.set(key, value),
            removeItem: key => ls.remove(key)
        }
    })]
})
// check if user is logged in, token will expire on resignation date
store.isExpire = () => { return (Date.now() < store.state.expire && (store.state.user.resignation_date == null || moment(store.state.user.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))) };

export default store
